import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '.';

export interface ISalesItemAttributeTypeModel extends IModel {
  salesItemAttributeTypeId: number;
  name: string;
}

export class SalesItemAttributeTypeModel
  extends Model
  implements ModelRecord<ISalesItemAttributeTypeModel>
{
  salesItemAttributeTypeId: number;
  name: string;

  constructor(params?: Partial<ISalesItemAttributeTypeModel>) {
    super(params);
    this.salesItemAttributeTypeId = defaultTo(
      params?.salesItemAttributeTypeId,
      0,
    );
    this.name = defaultTo(params?.name, '');
  }
}
